/**
 * Creator Collabs apply modal — POST multipart to internal Worker
 * (same pattern as listed installer applications; no Slack).
 */
(function () {
  var WRAP_SEL =
    ".hmc-creator-form__field, .hmc-creator-form__checks, .hmc-creator-form__terms";

  function digitsOnly(value) {
    return String(value || "").replace(/\D+/g, "");
  }

  function wrapFor(el) {
    return el && el.closest ? el.closest(WRAP_SEL) : null;
  }

  function messageFor(el) {
    var v = el.validity || {};
    if (v.valueMissing) {
      if (el.type === "checkbox") return "Please check this box to continue.";
      if (el.tagName === "SELECT") return "Please choose an option.";
      return "Please fill this out.";
    }
    if (v.typeMismatch && el.type === "email") {
      return "Enter a valid email address.";
    }
    return el.validationMessage || "Please check this entry.";
  }

  function clearFieldError(el) {
    el.removeAttribute("aria-invalid");
    var wrap = wrapFor(el);
    if (!wrap) return;
    wrap.classList.remove("is-invalid");
    var msg = wrap.querySelector("[data-hmc-field-error]");
    if (msg && msg.parentNode) msg.parentNode.removeChild(msg);
  }

  function showFieldError(el, text) {
    el.setAttribute("aria-invalid", "true");
    var wrap = wrapFor(el);
    if (!wrap) return;
    wrap.classList.add("is-invalid");
    var msg = wrap.querySelector("[data-hmc-field-error]");
    if (!msg) {
      msg = document.createElement("span");
      msg.className = "hmc-creator-form__error";
      msg.setAttribute("data-hmc-field-error", "");
      wrap.appendChild(msg);
    }
    msg.textContent = text;
  }

  function init(root) {
    if (!root || root.getAttribute("data-hmc-creator-ready") === "1") return;
    root.setAttribute("data-hmc-creator-ready", "1");

    var endpoint = root.getAttribute("data-endpoint") || "";
    var modal = root.querySelector(".hmc-creator-modal");
    var form = root.querySelector("[data-hmc-creator-form]");
    var success = root.querySelector("[data-hmc-creator-success]");
    var successTitle = root.querySelector("[data-hmc-creator-success-title]");
    var successMessage = root.querySelector("[data-hmc-creator-success-message]");
    var errorEl = root.querySelector("[data-hmc-creator-error]");
    var submitBtn = root.querySelector("[data-hmc-creator-submit]");
    var openBtn = root.querySelector("[data-hmc-creator-open]");
    if (!modal || !form || !openBtn || !endpoint) return;

    function openModal() {
      modal.hidden = false;
      document.documentElement.classList.add("hmc-creator-modal-open");
      document.body.classList.add("hmc-creator-modal-open");
      if (success) success.hidden = true;
      form.hidden = false;
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = "";
      }
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.classList.remove("hmc-creator-modal-open");
      document.body.classList.remove("hmc-creator-modal-open");
    }

    function resetForm() {
      form.reset();
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = "";
      }
      form.querySelectorAll(".is-invalid").forEach(function (el) {
        el.classList.remove("is-invalid");
      });
      form.querySelectorAll("[data-hmc-field-error]").forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
      form.querySelectorAll("[aria-invalid]").forEach(function (el) {
        el.removeAttribute("aria-invalid");
      });
    }

    /* Returns the first invalid control, or null when the form is complete. */
    function validate() {
      var firstInvalid = null;
      form.querySelectorAll("input, select, textarea").forEach(function (el) {
        if (el.disabled || el.type === "hidden") return;
        if (typeof el.checkValidity !== "function" || el.checkValidity()) {
          clearFieldError(el);
          return;
        }
        showFieldError(el, messageFor(el));
        if (!firstInvalid) firstInvalid = el;
      });
      return firstInvalid;
    }

    function revealInvalid(el) {
      var wrap = wrapFor(el) || el;
      try {
        wrap.scrollIntoView({ behavior: "smooth", block: "center" });
      } catch (err) {
        wrap.scrollIntoView();
      }
      /* Don't pull up the keyboard on touch — it fights the smooth scroll. */
      var finePointer =
        window.matchMedia &&
        window.matchMedia("(hover: hover) and (pointer: fine)").matches;
      if (!finePointer || typeof el.focus !== "function") return;
      try {
        el.focus({ preventScroll: true });
      } catch (err) {
        el.focus();
      }
    }

    openBtn.addEventListener("click", openModal);
    root.querySelectorAll("[data-hmc-creator-close]").forEach(function (el) {
      el.addEventListener("click", closeModal);
    });

    modal.addEventListener("click", function (event) {
      if (event.target === modal.querySelector(".hmc-creator-modal__backdrop")) {
        closeModal();
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !modal.hidden) closeModal();
    });

    form.querySelectorAll("[data-digits-only]").forEach(function (input) {
      input.addEventListener("input", function () {
        var next = digitsOnly(input.value);
        if (input.value !== next) input.value = next;
      });
    });

    function recheck(event) {
      var el = event.target;
      if (!el || !el.matches || !el.matches("input, select, textarea")) return;
      if (typeof el.checkValidity === "function" && el.checkValidity()) {
        clearFieldError(el);
        if (errorEl && !form.querySelector(".is-invalid")) {
          errorEl.hidden = true;
          errorEl.textContent = "";
        }
      }
    }

    form.addEventListener("input", recheck);
    form.addEventListener("change", recheck);

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = "";
      }

      var firstInvalid = validate();
      if (firstInvalid) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent =
            "Please fill out the highlighted fields below.";
        }
        revealInvalid(firstInvalid);
        return;
      }

      var collabBoxes = form.querySelectorAll('input[name="collab_type"]:checked');
      var collabTypes = Array.prototype.map
        .call(collabBoxes, function (el) {
          return el.value;
        })
        .join(", ");

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = "Submitting…";
      }

      var fd = new FormData(form);
      fd.set("terms_accepted", "1");
      fd.set("phone", digitsOnly(fd.get("phone")));
      fd.set("collaboration_types", collabTypes);
      fd.delete("collab_type");

      /* Also send as media_kit_url so older API builds still persist the answer */
      var productInterest = String(fd.get("product_interest") || "").trim();
      if (productInterest) fd.set("media_kit_url", productInterest);

      fetch(endpoint, {
        method: "POST",
        body: fd,
        credentials: "omit",
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.body || !result.body.ok) {
            throw new Error(
              (result.body && result.body.error) || "Submission failed"
            );
          }
          form.hidden = true;
          resetForm();
          if (success) {
            success.hidden = false;
            if (successTitle) successTitle.textContent = "Application submitted";
            if (successMessage) {
              successMessage.textContent =
                result.body.message ||
                "Thanks — we’ll email you if there’s a fit.";
            }
          }
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent =
              err && err.message ? err.message : "Submission failed";
          }
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = "Submit application";
          }
        });
    });
  }

  function boot() {
    document.querySelectorAll("[data-hmc-creator-collab]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll("[data-hmc-creator-collab]").forEach(function (el) {
      el.removeAttribute("data-hmc-creator-ready");
      init(el);
    });
  });
})();
